import { render, staticRenderFns } from "./Input_Radio.vue?vue&type=template&id=07c78a58&scoped=true&"
import script from "./Input_Radio.vue?vue&type=script&lang=js&"
export * from "./Input_Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c78a58",
  null
  
)

export default component.exports